var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nebToggle",class:{
    off: !_vm.value,
    on: _vm.value,
    disabled: _vm.disabled
  }},[_c('div',{staticClass:"nebToggle-toggle",on:{"click":_vm.toggleValue}},[_vm._m(0)]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.label),expression:"label"}],staticClass:"nebToggle-label"},[_c('label',[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nebToggle-toggle-housing"},[_c('div',{staticClass:"nebToggle-toggle-circle"})])}]

export { render, staticRenderFns }